import { WorkType } from '@adminModels';
import { CreateWorkTypeData, UpdateWorkTypeData } from '@adminStore/work-types';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  workTypesControllerCreate,
  WorkTypesControllerCreate$Params,
  workTypesControllerDelete,
  workTypesControllerFindAllAdmin,
  WorkTypesControllerFindAllAdmin$Params,
  workTypesControllerUpdate,
  WorkTypesControllerUpdate$Params,
} from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface WorkTypesQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  sortBy?: 'createdAt' | 'name' | 'ratePointsPerHour';
  sortOrder?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class WorkTypesApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: WorkTypesQueryParams): Observable<PaginatedResponse<WorkType>> {
    const apiParams: WorkTypesControllerFindAllAdmin$Params = {
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      isActive: params?.isActive,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    };

    return workTypesControllerFindAllAdmin(this.http, this.apiConfig.rootUrl, apiParams)
      .pipe(map(response => toPaginatedResponse<WorkType>(response.body)));
  }

  create(workTypeData: CreateWorkTypeData): Observable<WorkType> {
    const params: WorkTypesControllerCreate$Params = {
      body: workTypeData,
    };
    return workTypesControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as WorkType));
  }

  update(id: string, workTypeData: UpdateWorkTypeData): Observable<WorkType> {
    const params: WorkTypesControllerUpdate$Params = {
      id,
      body: workTypeData,
    };
    return workTypesControllerUpdate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as WorkType));
  }

  delete(id: string): Observable<void> {
    return workTypesControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}
